/**
 * Temporary compatibility entry point.
 *
 * New code should import from `@louise/theme/tokens`. Keep this file until
 * the existing consumer groups have migrated and the old package path can be
 * removed safely.
 */
import {
  cardSurfaceStyle,
  colors as canonicalColors,
} from "../../theme/tokens";

export {
  cardSurfaceStyle,
  colors,
  gradients,
  semanticColors,
  typography,
  spacing,
  radii,
  shadows,
  springs,
  HEADER_INSET,
  SCREEN_PADDING_TOP,
  withAlpha,
} from "../../theme/tokens";

/** @deprecated Use `cardSurfaceStyle` from `@louise/theme/tokens`. */
export const GLASS_CARD_STYLE = cardSurfaceStyle;

/**
 * @deprecated Use semantic tokens from `@louise/theme/tokens`. The accent
 * names follow the colour roles (#3910): `warm` (the tan) is the copper
 * accent, `coral` (the soft coral) the danger red, `green` (the mint) the
 * success green and `gold` (the butter) the warning yellow.
 */
export const EMBER = {
  colors: {
    warm: canonicalColors.accent,
    warmDark: canonicalColors.warmDark,
    warmLight: canonicalColors.warmLight,
    coral: canonicalColors.danger,
    teal: canonicalColors.teal,
    blue: canonicalColors.blue,
    green: canonicalColors.success,
    gold: canonicalColors.warning,
    text: canonicalColors.text,
    textMid: canonicalColors.textMid,
    textLight: canonicalColors.textLight,
    textFaint: canonicalColors.textFaint,
    bg: canonicalColors.bg,
    bgEnd: canonicalColors.bgEnd,
    border: canonicalColors.border,
    surface: canonicalColors.surface,
  },
} as const;
